import React from 'react';
import ReactDOM from 'react-dom/client';
//import './styles/whiz-styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import './styles/whiz-styles.scss';  // Import your main styles
import './styles/whiz-styles.css';  // Import your main styles
//import './styles/fonts.css';        // Import your font-specific styles


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
